import { FC, HTMLAttributes, useEffect, useRef } from "react";
import { useStyles } from "./LoadMore.style";

interface ILoadMoreProps extends HTMLAttributes<HTMLDivElement> {
  loadMore?: () => void;
}
export const LoadMore: FC<ILoadMoreProps> = ({ loadMore }) => {
  const classes = useStyles();
  const observerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) loadMore?.();
      },
      { threshold: 0.1 },
    );

    if (observerRef.current) observer.observe(observerRef.current);
    return () => observer.disconnect();
  }, [loadMore]);

  return <div ref={observerRef} className={classes.observerRef} />;
};
